import React, { useCallback } from 'react';
import { useEffect } from "react";
import { staff_title_long } from 'components/langutils';
import { useData } from '../Data';

export function HashSelect() {
  const { setType, type, current, setCurrent, lang, fields, groups, projects } = useData();
  const hashchange = useCallback(() => {
    const hash = document.location.hash.slice(1)
    const [current_semester, current_course_id] = hash.split(':', 2)
    
    const head = document?.head?.getElementsByTagName('title')?.[0];
    if(current?.[0] !== (current_semester ?? null) || current?.[1] !== (current_course_id ?? null)) {
      setCurrent([current_semester ?? null, current_course_id ?? null]);
    }
    if (head) {
      //head.innerText = current?.full_name ?? (staff_title_long(lang));
    }
  }, [setType, current, setCurrent, fields, projects, groups]);
  useEffect(() => {
    addEventListener('hashchange', hashchange);
    return () => {
      removeEventListener('hashchange', hashchange);
    };
  }, [hashchange]);
  useEffect(() => {
    hashchange();
  });
  return <></>;
}
